export const PackageColumns = [
  {
    Header: "Package Name",
    accessor: "name",
  },
  {
    Header: "Package Description",
    accessor: "description",
  },
  {
    Header: "Package Price",
    accessor: "price",
  },
  {
    Header: "Created On",
    accessor: "created_at",
  },
  {
    Header: "Room Type",
    accessor: "room_type",
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
  },
];
export const PackageData = [
];